import { Location } from 'react-router-dom';

// navigateHelper.js
let navigateFn: (arg0: string) => void;
let pathLocationFn: Location<any>;

export const setNavigator = (navigate: (arg0: string) => void) => {
  navigateFn = navigate;
};

export const setPathLocation = (pathLocation: Location<any>) => {
  pathLocationFn = pathLocation;
};

export const navigate = (path: string) => {
  if (navigateFn) navigateFn(path);
};

export const getPathLocation = () => {
  if (pathLocationFn) return pathLocationFn;
};
